import AbstractStore from "../../Common/Stores/AbstractStore";

export default class BasketStore extends AbstractStore {
    constructor() {
        super(["load"]);
        this.state = null;
    }
    load(state) {
        this.actions.load(state);
    }
    onLoad(state) {
        this.state = state;
        this.trigger(state);
    }
}

export function createBasketStore(initialState) {
    const store = new BasketStore();
    store.onLoad(initialState);

    return store;
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Stores/BasketStore.jsx